import { render } from "./DefSale.vue?vue&type=template&id=296170a3&scoped=true"
import script from "./DefSale.vue?vue&type=script&lang=js"
export * from "./DefSale.vue?vue&type=script&lang=js"

import "./DefSale.vue?vue&type=style&index=0&id=296170a3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296170a3"]])

export default __exports__